import React from 'react';
import { useLocalizedText } from '../../hooks/localizedText';
import { Alert, AppLayout } from '@amzn/awsui-components-react';

export function UnsupportedSignupLayout({ contentOnly = false }: { contentOnly?: boolean }) {
  const { t } = useLocalizedText(['signup']);

  const content = <Alert type="info">{t('manageSignupsPage.unsupportedSignupType')}</Alert>;

  // New nav: the root AppLayout already provides the page frame (a single <main>). Rendering our
  // own AppLayout here would produce a second <main> region, which is invalid HTML and makes
  // screen-reader region navigation ambiguous (CR-291797692 rev 7).
  if (contentOnly) {
    return content;
  }

  return (
    <AppLayout footerSelector=".footer" navigationHide={true} toolsHide={true} content={content} />
  );
}
